<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Vehicle Types</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item active">Vehicle Types
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="card">

                <div class="card-body">
                    <form novalidate @submit.prevent="saveVehicleType">
                        <div class="row">
                            <div class="col-12 col-sm-6">
                                <div class="form-group">
                                    <div class="controls">
                                        <label>Name</label>
                                        <input type="text" v-model="vehicleType.name" class="form-control"
                                               placeholder="Name"
                                               required>
                                        <div v-if="vehicleType.errors.name" class="text-danger text-small">
                                            {{ vehicleType.errors.name }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-sm-6">
                                <div class="form-group">
                                    <div class="controls">
                                        <label>Description</label>
                                        <input type="text" v-model="vehicleType.description" class="form-control"
                                               placeholder="Description"
                                               required>
                                        <div v-if="vehicleType.errors.description" class="text-danger text-small">
                                            {{ vehicleType.errors.description }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 col-sm-6">
                                <div class="form-group">
                                    <div class="controls">
                                        <label>Minimum Weight (Kg)</label>
                                        <input type="number" v-model="vehicleType.min_weight_kg" class="form-control"
                                               placeholder="Minimum weight (Kg)"
                                               required>
                                        <div v-if="vehicleType.errors.min_weight_kg" class="text-danger text-small">
                                            {{ vehicleType.errors.min_weight_kg }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-sm-6">
                                <div class="form-group">
                                    <div class="controls">
                                        <label>Maximum Weight (Kg)</label>
                                        <input type="number" v-model="vehicleType.max_weight_kg" class="form-control"
                                               placeholder="Maximum weight (Kg)"
                                               required>
                                        <div v-if="vehicleType.errors.max_weight_kg" class="text-danger text-small">
                                            {{ vehicleType.errors.max_weight_kg }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-sm-6">
                                <div class="form-group">
                                    <div class="controls">
                                        <label>Base Price</label>
                                        <input type="text" v-model="vehicleType.base_price_per_km" class="form-control"
                                               placeholder="Base price"
                                               required>
                                        <div v-if="vehicleType.errors.base_price_per_km" class="text-danger text-small">
                                            {{ vehicleType.errors.base_price_per_km }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-sm-6">
                                <div class="form-group">
                                    <div class="controls">
                                        <label>Multiplier</label>
                                        <input type="text" v-model="vehicleType.multiplier" class="form-control"
                                               placeholder="Multiplier"
                                               required>
                                        <div v-if="vehicleType.errors.multiplier" class="text-danger text-small">
                                            {{ vehicleType.errors.multiplier }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="isEditing" class="col-12 col-sm-6">
                                <label>Current Image:</label><br>
                                <img v-if="vehicleTypeData.image_url" width="70%" style="height: 150px; border-radius: 10px;" :src="vehicleTypeData.image_url" alt="">
                                <span v-else><b>No Image</b></span>
                            </div>
                            <div class="col-12 col-sm-6">
                                <label class="form-label">Image</label>
                                <file-pond
                                    v-if="true"
                                    name="image"
                                    ref="imageData"
                                    label-idle="Drag & drop image"
                                    :allow-multiple="false"
                                    accepted-file-types="image/jpeg, image/png, image/gif"
                                    data-allow-reorder="true"
                                    data-max-file-size="3MB"
                                    :files="imageData"
                                />
                            </div>

                            <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mt-1">
                                <button type="submit" class="btn btn-primary glow mb-1 mb-sm-0 mr-0 mr-sm-1"
                                        :disabled="saving">
                                    {{ isEditing ? 'Update' : 'Save' }}
                                    <i class="fa fa-spinner fa-spin" v-if="saving"/>
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import vueFilePond from "vue-filepond"
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";

const FilePond = vueFilePond(
    FilePondPluginFileValidateType,
    FilePondPluginImagePreview
);

export default {
    metaInfo: {title: 'Create VehicleType'},
    name: 'VehicleTypeCreate',
    props: ['isEditing', 'vehicleTypeData'],
    layout: Layout,
    data() {
        return {
            vehicleType: this.$inertia.form({
                name: null,
                description: null,
                image_url: null,
                base_price_per_km: null,
                price_per_minute: null,
                min_weight_kg: null,
                max_weight_kg: null,
                multiplier: null
            }),
            imageData: null,
            saving: false,
        }
    },
    methods: {
        async saveVehicleType() {
            this.saving = true;

            if (this.$refs.imageData && this.$refs.imageData?.getFile()?.file) {
                this.vehicleType.image_url = this.$refs.imageData.getFile().file
            }

            if (this.isEditing) {
                this.vehicleType.post(
                    route('admin.vehicle-types.update', this.vehicleTypeData.id),
                    {...this.vehicleType},
                    {
                        forceFormData: true,
                        preserveScroll: true,
                        onSuccess: () => this.saving = false,
                        onError: () => {
                            this.saving = false;
                        }
                    }
                );
            } else {
                this.vehicleType.post(route('admin.vehicle-types.store'), this.vehicleType, {
                    forceFormData: true,
                    preserveScroll: true,
                    onSuccess: () => this.saving = false,
                    onError: () => {
                        this.saving = false;
                    }
                });
            }

            this.saving = false;
        }
    },
    mounted() {
        if (this.isEditing) {
            this.vehicleType.name = this.vehicleTypeData.name
            this.vehicleType.description = this.vehicleTypeData.description
            this.vehicleType.image_url = this.vehicleTypeData.image_url
            this.vehicleType.base_price_per_km = this.vehicleTypeData.base_price_per_km
            this.vehicleType.price_per_minute = this.vehicleTypeData.price_per_minute
            this.vehicleType.min_weight_kg = this.vehicleTypeData.min_weight_kg
            this.vehicleType.max_weight_kg = this.vehicleTypeData.max_weight_kg
            this.vehicleType.multiplier = this.vehicleTypeData.multiplier
        }
    },
}
</script>
